import React from 'react';
// import ReactDOM from 'react-dom';
// import ReactPlayer from 'react-player/youtube'
// import { PieChart } from 'react-minimal-pie-chart';
// import { Bar } from "react-chartjs-2";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from "recharts";


// import { Chart, registerables } from 'chart.js';

import "./Home.css"
import 'antd/dist/antd.css';
// import VideoPlayer from 'react-video-js-player';
import qrcode from "./qrcode.jpeg"
// import vid from "./attributeselector.mp4"
// import { Card, Button } from 'antd';

// const gridStyle = {
//   width: '25%',
//   textAlign: 'center',
// };

function Home() {


  const data = [
    {
      name: "Page A",
      uv: 4000,
      pv: 2400,
      amt: 2400
    },
    {
      name: "Page B",
      uv: 3000,
      pv: 1398,
      amt: 2210
    },
    {
      name: "Page C",
      uv: 2000,
      pv: 9800,
      amt: 2290
    },
    {
      name: "Page D",
      uv: 2780,
      pv: 3908,
      amt: 2000
    },
    {
      name: "Page E",
      uv: 1890,
      pv: 4800,
      amt: 2181
    },
    {
      name: "Page F",
      uv: 2390,
      pv: 3800,
      amt: 2500
    },
    {
      name: "Page G",
      uv: 3490,
      pv: 4300,
      amt: 2100
    }
  ];

  // const descriptionWatch = () => {

  // }

  return (
    <>


      <div className=''>
        <div className="homeContainerOriginal">
          <div className="frontContent">

            <h1 className='frontContentHeadig'>Warm Welcome</h1>


            <h2 className='frontContentSallHeaing'>Let's Grow</h2>
            <p className='frontContenPara'>We provide projects for B.E. or B.Tech
              based on Mern Stack and ROR and also quiz to practice for exam.</p>
          </div>
        </div>








        <div className="latstArticleContainer">
          <h2>Latest Project</h2>
          <span className='projectTitleWidget'></span>
          <div className="latestarticlrowone">
            <div className="one same">
              <img src="https://blog.planview.com/wp-content/uploads/2020/01/Top-6-Software-Development-Methodologies.jpg" alt="" />
              <p><strong>Tech Stack : </strong><span> abc</span></p>
              <p>Description</p>
            </div>
            <div className="two same">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAACeVBMVEXVPkmCwOrf8Pv////o9ft7venk9PrJ6PW84u/d8PkTIDXGJkHZMzztj38AAACAwu2coML5/P/Q6PhrxdrUKDW03erVOUTa6/Dn5+3UP0nlKkRFWmjVMz7M4fbX7Pqw1/LTcH3g+P/L7f/i6fV+isIAABvw+/+Ht+FFW6jl7/IKGC/ulYOdU1vNq4vsIDfNMUVNsMK81u3thHfihJUkOYZkf7kApMZbmNN/rdzMHDv55+fSg5HOx9oAHzTUVGAAACChxOUmW6aii5velp/lk5jN0ubRlKTVS1bPuMkthI4ARpvqb2sAABPrzsxgj7AAUqEXJkgAGUyryuj4p4HLU2Tcx9HFX3TTZnPQqbr7tYDWHyqZy+7PsMFAlqNgucwSNWRGdrg+VoA3QFC2xdDpaGdRZq0aMIJBgr2astEAFTcfNHHoV1ySusNsotciT5D0l2mjkbLBa4Ct3/qwhKLRjp2Fg46SqLquNUA1NT1OVl/CkqYcMzvajHK9gWZHOzj3wLLct73vf0DxraTWDxyqiquvpcRYKDp4LT5yp7pzYWqKMEAdOlHMubY5bHWuS1Y2IzkiEjCZhXjog4L/snF4VC6lmZHOl3+oeViGalObU3soRnPMsY9+YJa8vb7xJyGuZoWYbW1IBB8qV2t2wyYwTTNvanpGdyo+ZjFKW4tqXFpYRlAiN1hPhpqgq7AnJSl5TU1cbYZFUlWMNWn/lnfjrqoDIGaBPClYLiBrPR4AKV/Iem9If39FgJVIntlqXnM2GAWdaFC0KlTzuJu+clMAADZ4Lk6pcnFZNUm9N3WnSVKAADyncHt2TYeIBTq6YV8gaZ1IhKxvNllVNmF5wJbVAAAdBElEQVR4nO2di19TZ5rHk5MbCQmQEA5JPOeEcDnRRIGTSpNwCYkYI3eacFOKRIElAgG14G3syGitaMVOO9bb6LbTXXdxqGPtOG0t68w4TrvTy1R3/6J93vec3EDbzn46NcH8ptVPITA5X57n9zzv877nIBJllVVWWWWVVVZZZZVVVllllVVWWWWVVVZZZZVVVv+AKDWlVpPP+l2kk0jRPlm+dV+3+lm/kbQQDg19b/DAgEyWn78vGyoikuo2qkn9nIUg5IRZJs63Gp93KPpea35+pBshQWLEAEX0fENR9x8wiyFjiLgGxPkR/bN+W89SlAHFh1nGJZgQECmvPcdGS/XjlJFzDI/DgNMHPKX7+c0eqoxIFruzB/3FyfIjz22gkB5LAoilxyMJBJQobMBS9j+vgUKWJJgo604aJcYmnD062fNrs0lMSs0HjpISUW0TIQRK73MaKGRfEhPzAY4V1W7tEQJl33PrKD1xKAwNVIBJreAo4ueWib6kLEZFbpZhJthRzLLnNnkgffRNhJKHIjDZWoZ7lPxXqGf93v75etolUqSw1okxmUNBI84vWNPJg5KAEs0Yn0ZF7+mxJJhskONVT751DVdjUl9iJPV1NE3P6J9iESSyFaVZNkAathqUcjkGZH3aqzNfVLe/NNDnp2eo2YP+kqdT2UYcsJaKDHUGNEYhCFqWb+1eo45CzpT2e7aX9pOHfnb48JHS7YGnuQRlPGq0iCBOhNI8IMtfs6Un4NlWWu9Ri/bs2XM473x9aT/1VLM1lor8dYZEaRaLjT/pW/2JhI0EZwwgafvZIX2Jn65D/0munrpSolKjv84fa+LkECkFa9Bn9chI0NWTnmOvvvrzV48bKfUM7e/TkyX1K9yCRLj09QkmeLi05uYolBGMJFCHrp2a0+zYseMXtZoASYleBlsht5duS4ai9kBa6QN0Xb0/3u6Dz66xJoWikJHAv3BZ1EyZI7Rj+vhxjT2A+pH60m07+0oSMUCR/aX1AXV/6XbKX+cxWGLZIxavpdKDjaRuZz39ArIEPa1zaE4cP+Gwj6gpnCfok2TSa/0lJ1FSnZwpraP0dUSss11LpUfdDaEAl+8hcRNbV8ppkOymJsMcKjykGgKoGzsoiU3nJPxRdxI5MIVCjJ/TrqlVDwVZkNTKq/06rx0xGTnKSi0ELjzIbF6G11AB+FsNf4CboD6G/yp1ALX7UnH+a2uGiR4Krii+nUf2lXIRBwoT9SlCKiUshj6cUBAa21C8eHYiN0F/eOKWCtFjsMgH1hQTMNDA6wIVql/n3d+KU+cozUrxPBr1s8hHSumSk9hN0B8pnT+aIgwUPJv3/88QZkKebjiNqej95shOnsl+DjMBbaMo0qMm63Z2C26ybVUXR4n2r6GeDTMRGRsaEBV1d6m3t8SOmQTMMSaWspL5wTMi5CokyVvLaq2dohNjQp5tUDU0nD0ltkZ6COQnGtPJSIwJUCksrG6eBDepo+s9ayggniKeiUikAjW8YbVaB84hJo7KPoM0zoQoBFUvnFeXrLSSNakYEwgUlcr24QBQiTRpNBNNLI9EGWdSWDi4LqBPKTlrVDEm5KE3gUqFFWn43IlaHomlXdNu4ZkMDhYW7ho8o05qTdaqYkwQlV/utb0PgRKBNaCBNbxlIZRvQxq9bcFMdlU3VyNb2bgTNbM4gcg1mkUJJiLRxbcOV7iskV8BE+31C+9A4pjIVpOJZwJIqpt3IVsx6mewrZB1fWvMb4VRUVKcXNy0adPPl6zDly5dunz5woVixASJZzJYPdi8axBBeY9Ei+PtqKd9eU2N18gro1cQlQQT4683bbpw4cJbQAaQXC5G3jpnqjShTZwiBAWQDKIkuq0Whig7PfWeZ3sVP6rI1xuuhke71UlMAsDkXHEZILl44fI5lj9WIeeXvQSDYDQPVkOc7DqIyjEettXtXEtmS74J7chi+JpxZ8JPgMavLec2bbp04Tor0WpR3WGCVnR+TUqLxYWYCmIyaelB5ZjkZ5PP9DJ+VCEmZxu6psJXUv2EASTvoG1gVquFUAlCZaalaLeiUDZwju9Sds0SFsscKseUEc0m10yokEcqGv717BttS+Hwu8KKLsbkwkEGbWVJtShUdGY0QxOLZWLaYtfcwkzeM22zWIgmVI7RbPLoU7c8Mkx6w7DqN78pfF9l420FRB4TmPyxxUXEqchpMUJilusIu8ZhnwQmb2lGRD0Wi0GwFZrf8sh86Q0se6vt/Tf+7d9tKrAVdJSA/AyYgMVeuDHW4gvi7XFWK8FBMkAQkD6wXm5VNyEmdo16Lj5aScwmM1x6WOGxxTfa/uM/96pUkEBXKBIxuWQAJouFYV9LmJPiUBGDaCkik78VmDgmJppIWCQ6XkD1yIK3CqnAy08ZIGSWEBOgMrynAi2IbUvh0V516683XToHVSccDjt9nS1OBs+exTIWbGUAoFibHI6JEQeJZk48E0KY2Or7/KXbMj6BEJN2g5Rlh1WNiIrqavgaxMnlS9CvddaEX/PVAJUgYiIzS8Br5TqwlfwIWIqotTUeJ4gKnthSJ2MbqxksYCJ3ONohVKSzjTYcK1OogYV/bg5N+TRjY+FwZ4RnwlcgfHNK/nbIH5EmiQlQeVlNzUCjsi3TpwiICVyZpp3FtmJTNd4wSGrPXdh06fIN39RQ51ihLxwW4iRWl8FnxfnifofGkcJkwKoXGftLZ/AGx1PPfWWAMBNHbbvjBG8rebMSyfXZI7+FFc9un9M3NOQL1/i8coFJrIVDtpLvdSTHiVmGj26pPQFhSyxzE4hn0i6xQ/7Ii6EuH5k9XNHYZqg991ZnZzhcMwUJlIiTeAtHcGKoySMxJlLcvODjbPxgSr9qnyODBEwsmhPttRrMRMoGudkKW+N1icSwFPYhKuGpoc2RJCZxKmbZ9pH92x2nSvEJJVSqk4/4URQaTmZmAgET1lErqT0hMImsL/ff2CORbDhsWxoFKuAm4fGDAhO5mBZaOK0WkWiqlOXn00ozJpLKBO2V1pfOZCQUXIshdyQ8E6l//fr1keEbRypsuC6PYioRwU+k+Y+P6DAVLW8r26AY4bRZzYREQ7i+jMwe3LMZ7JraEzwTraRg/frR4C0b360sogTyxfxEmt/R1jarTKwMlXwTt5pJRtssYlJczLYLfgJMJIby9etr/LM4UlRdQKUlkmCye6nNdksesxUiiUgyE3VGl2OeSbFSerc2xkQiKRtdv758mM8f1O672DiTpd0fvNG2Zxhv+WglHEYiG0j1WN5fM7dtE5gUF8ulcSZ7rkt4W9kjtPujNTQhMFncvbCwaMtbh21FiomIObk8UYszvA4jYT8plrPFxUlM2vZItIKt4ARSTflcYjFmYltaXHp0dXdF2yyKFDxRSenZ8DJwZmcGExGYSGYNKUxsbQYttpXymK0sTY26MJO9qqWlzw7XLC21fQiRIpMNMPG95AHXTv4Ik77On6lWggVMtIbf5UliTKQs9PaNeYYNGyQSP9hKAdgKgtI2Feb9pKvLdvvIfFfNEmIi1iW216E0l+D1H6o4GR4nktm8vN9p0RQF97F+VivRzgITRCUCCRQZ/hmylaXRoFQOdecRovLB7t1XXXJipSwMGIn65QzfRla/DUGSl3dHEmMSaSknWFR7NhQjKtqC8vJR/y00RRidnwQmFbaa3UBFtXi1YzUTEPDI7FE1Sd6FIAHdlMaY4IIj5amAtJIygBLccKOtwsflzM93NKpsKnCTrooP6SchIYQ5fsaKfPtcHq93pHGPxQUHJZBEouUTyD8aYdnhPWGFghn+oMGGWpYa2/DKKFHG7hFEA7fMpWKcO3frMGZyi0VQhLpThvpYmqciQVAkZch7i6Ico1BMLqgQlVmJdAWTOcddZSxWep56y0/6i6ICtZjJ9WIhd/g+FhccAlORYDTos0XrNjsVDKOYf99maxwW9kzjUdKqsWta4yM3ZX/mRgo5cisv70henkGe3J9IcMFZDxnD/0eMSUVXpwuo5EB3PywM3OIQTKYRfBiDl5w5lbGRou/JyzssuZWHG/w4Ez/CkLCVOBNImns+L6NgJt8fjo+WBMUOqPAyyzL2jhWq6Q7ECCu5uSEld2pGEZWyGuhjy1htChOVajzMKZnJYXTlyVR6ApUTPUKQoLlkpjIhPZA5s9r2dq02JXfKR1sStiJnU5moujY7dQodf/kJKkrLdj5K8AZQ5t5+TbVDB3u3h8WLnaTcgbqj3YCpoAQCW2GTmahUQy1BJcEkD9ygr/dag3i/kB8bZCwTsulW3nWRfg4VYnlS7lz3r9/AbsBUDOWoj40zabi3+R5AyePQkMmaOHRAEBw6oMIfx8hsJhOa9q0krO4trDRlXbxnGDexG3AClRdAqPBMGm6Pb968ucu2jtERTP5YS0SeSCCGI5JGsxnLxGHXaIzovhRFlGHlidw5YsszSBJU6tcLTG5rNJprAOUPB4uGERNfiw8fOuDrspxJGkRmDhMyYIR/Yks00tTqIE1GkVrHtbS4pGyCSWObAa2O+QUPWKyfzx3KYW8lgcm/6OZzEJOasK9ljI4lEJ08ms0YJkYIjK00XUcJZ7RwT2Ek6yzRzqm9Nujv5TwT7SwUaBQjrBAqQt1BL3cDknJmGcdJuLMw3Bk7yyQRizOQiZEasWvU9bR5ppU/KIyukRSptyt8XWCcFXuGWZ5JcbEhgSOJidtkqswFJtzkAs8kPBau8bV0YlvRyTKRCWZQWeC1btNovj4YIEVG0iSC1OnxjrfhQxZtN4pxi1ZcVBQfFaT0sWdNH0HqTFmWf4aZTHXWjNaEazpbfHSGMqF4JjVWa12raUthIXrEHDoRTpZYzOGX+KMnjbfQ6AQx2ZDkJ3EmUIohTCJFy22YyfhQp+/3YRAqQJnIhNpSuKWSZ9JbWbll14tbkNeSar3+5Ewp4wVDUXV1qRpVwxAqxUUSnDkICpvS23cBE1ju/JXPHd/Q0FTsgEoGMqFm0S0VAhOT6cyLL96g8H6dolSxvV6hULjGbaqhcd5WtJIn+gmOpXvlimVVheAn6CgGxIkvQ5msa65+8cVkJuer0H6dIiZG4bzXphq/p7JVzBYnV+IVTCoUkwu2RsxEOIrBH1DJPCakfl1zcxKT7nf1lL6OMyuSxHDhl9q6xodUjY230OhktZ90oR7WsrwH4kRKQJws7p2qCYeHhjq9GciECrz8QZyJuNfkrqL0ff4Bq9UL8cHr7l2gArbSNjQes5VVfgIW+4fhouW9qq6OMa94rIYuWHrJB53bvUjaMjF+/MkD45NuLqK20TQ9mWDirlIbt5cqYN3GKQ4U5RTlKOrR2TSwFR2ylXvjUJfXFQtz6iQm47zDVgz5On2dnVM1NM0VdN2DBPKmbd35+JPTpz/99NDqT6hrXFzQKjAp6KZIdT/D68ABeZBm5Yr+ytbWyn6UQDS2laXPPmucla+YPdpQD6tYDl+dmvKBEBOaDpbvHU9jP/n0T59+8umToKhrxpxWnonJ7QYjKbZgIkWFCg5oMQw7h8p0P04iJXQrpx12u+N13lZSmXCT/wUOMgW6EQ7TWMGll9I5TjCTj1d+nCTjTNy5pN7jtygBiFJRmKMLclY6SLt0Bk9lpccfM1vvlcqREdPphka+LseYdOEe9vH9sT+OD11799uxRZ4J/WEaMzGSH3/yp08+fbjiwwGH/SjPpAO81ThnUSIxhQcIndUZpYNOK0NEzXNzipx4CepHYfNR3FYEJvdQD9scjUanp3/xq79Ex8Jc+jOhWh+G/nws1LriwxMau8PjtIo/vKIn1U1KHsmBQiURdXpp9D/aGZUrvTpWGqei66usfPCmCuoydCvS2OwRmDDzF1tPlEUid/+ic45eHS3g0pwJOTM9/TAUCk2s+LjJNGHKvW9FHQl6RiNSTqGCcbpor9Ml5aJBmtO5IF50BJitoNLtPWbcrUBdRlMEzGQcHHYW3YxxvCdo2HFR1WC7WhNJaybkDLff8fDbueHVTEBXqii1p4cnoiw6QLs4Ouq06lCIcM6okoO6xLl0LKvkQ4WzDiiU0K2oULeC2n2WLbIhh72FmGgcW0M7dly6bFPZpsqD6czEHqqvr6fN5rdTzzrk5gKSXBI981UZkxTKDadDTsLRXivNRKO6oIvmGBfHJ1COFbdz8W6l4sbwrUYVOGzzF/iBQgAmtGUK9foNXaPlNX9N156NhLQJMjpQattWlZubW0Xqm+QCkuITdoNFznJOFyGHMCGCUHkgTKJBqxNadCvNUzFzuALRY8IiqLFR1QUOuyDCNx5Aqdbctl29arOpGq6O+jrTmMl0PUJSWrJiAxuIlAAGOUEAEgP8jB0QMlIp43QCQpeLsTo5Lhp1RpkgcOKSbYXvVrCtqIAJM7/RDV9uHwGL0nzWtTQ6evPe+qmpNJ4VhKYjHGLS41jBhAr0ABEkgNJTOTFS2YRiRsrQ1ihECOclvE5r0OsM6jjaZaVdRNxW+G4F2wo/JcjNFaE7JNHQ8vji6OhrO/4S+rCzszNdmRhD015ORwcj06HU5CFLcN3gqSh7TkLrgZkoIYG8cobxAhiai1qlECZyb5AL0lE6qS7DKhHPVrr+wE2ecee60Y1MECdNmq/HF3dM75gGJOk4ZyONAVI0Egp5kU79PpQaKNQcZhKjsrWyss8geK2chQTyslYwWwiXIK2LWlFZpgmrLoUKXXOvzbbO0nwevClg19jRyYpf7CjfMf3wvXCaMmmFrszYGrIjJMFZKhTCHyWFhQ/5nlwqTVAxRwrMykQFknqdUY5Ajmu10pBIQa/chbJIR0jlSQkUDP91uGjBDUzcgqFM79gxfayzZWgqLZmQE+hdOkKvdgSD3g8+D0yEWkkRGbi9MfagiuViNgGFs1qDRAKKkiWs0L6Bk3ihseUYK1Rpxuv06lyENNlWSq3M4EY3HycaDRhKaMf0F+Hw1s7xobRkgubxfYZQ6NX//u3nf/vb53/XQC+78c6R+Oc9C5PSeKhIlYxUjp8ZVXRAwScQbt+QkwAeL+tyQutCW4FSkq3Uby87eAYhycVPsiNNla99sQhp8/XjaOfQePrVYsykyTIXCr39N0Dy+VefXb50886dL+OuQuaeWR5mkxNILpfmFBbl5BQJVIJOZ5BATgJVOQjp5CWswSBHWBmpUoiT/TvdGEmuQ2DyylgY39wjC/s2px8TfV8f+s0ep74MhUqAyVe3Dx8+cvPOzYTRVuW6D90YTE4gqRIRARXlMNhW5LBElkrBSRgv5+WAjFcHwcNx0MYIy0KeSG7ue/hJdqbKfWOdPqcPUQmH024ea5wzi8VBhol8ddYeKun9/PDhw3du3vltIOklyBrPL0zKY1SURYU5MRXl8LaC2jdah5wkCmbrDXq5YBAcJeYnRQKTql+i4wWmyo98vrDPB1QggdKuZyM9B8zINgfyP//qo7dDoYvA5Mid93pSntGCGnz3xuWYrRQV5SRJSCBYBPVLlV7OyqECDQ0LNLSMTkAyeYRnIiJP71V9faz7G98oHUZUwujm/XTzWNITfWxmpIRZ5vr7V98iJr+7c/nh9HFLXUqXAlTcuWeaBVtR5uSsokLcBaOoldIuYYrAQtpA8w9pw0wu3+aDBL7RWZtt6B5ESAsj94bDYZQ6nenGRBSwPnrUUSqX6wbKv/pyenr62J+PPXw4Pe3dt+JeABQqh47EbEWRAgUxKat0aCZ6uSDDgZMQLNQnnY4f2w6eyXULRESiQ8BkaAqMhCPkhMuH77dNv9yZd0UfPRIzUqnZ9c3G0DSsj49dnJ4+uJIJn0BfxmxFrkgigleHaOD4AscwrDSIKjajLPPT6OD0wqEEEcxkCjPxswQh1TkRlZUeK7tf7q5a+UZ/QpEeV0eHq+DRmBl+bgdk+bdCCAoweXf1+e6YraQmkFKOXZYQVVZWbrMorRzL8h8pKyvzc8tfYieJfw9jgwo9xsDXqUPP/iDkQTCV1JmS7P798gdJX/HTC5g8egxYIIE4dKjMTJzDTDpWxQkSbyuDOQkqDL9eBlle6fXD4hCtFIXGvwxR2a9PBAnIaOvy4UDpbRcO3Ud8KXESve/s1T9LIqBAh2vsUYerAxLID6sUOh+YgJ+4nvCsbMoo2Mq6ecFWoNzEpghKr1VspZO6fiVcst9fRtf3JZvDIduQbxExydWXGCTodKxcxyWYQJBc0T/TxBGhOMnvQDxcHdB27fMPyO7fheIzPb3qOfOkxt5qMsZsBepyUg+HqcjpICFPEFEMa0EoVOijSd/qLDDpRclDitzupvhBap4JSpvcZ00ELrUbEqfD9RgSaN4ViURlsouh0DvT0++vZGLUHG/HUHACuW+vaveJWBJhd5lc3iLRYir+sqQqQp5umPKRiAn69u7cOZRAFoIolWEiNQ/0z5wIyoUI4sFT6YiIHz/eHgodhDhZmTtGu6PWPsF/ULCV4pWhEpN8ePmM+wVtO4YiLStPYvK6bcqnBiaj+DtV6btrJdqtE6bAvnzZfeeVZ20kMemPQocShVh5FCnveCyTuUKhjlDo/mvu1JeRjvZ2jeOM8AR7bCsL8yupYCxyxeCNQ253nbb2eC2OlGQmb9qmRknwk28E5FX6rXh7w1RVc8397NMmJqrqVMejMWQo/lOy+7KOi6GDF0MFq35ixhPt9mPVzbf5xwKvaPeTbEU5uXAe6q+7TiKpbT++golIZfNdCwCTK7FSX+XQAG27vbUyfYgg6bsLIHU6tr3ilVl3d0RCXxybXl11yG81mrd2FVY3f8lfIk6g1bYyuYxnR7nkViJS297eXpvCxGiz+b45lMxkwu4wdW/t9cBfZFo9WpfU749sQZON2cf50fuhi5+FVr89akv1cjN+7viCJ8lWUqYIbFFzrJEntwbLnsLkLDCJ/UoZstU+QWo0IyYRQPlJrvUfEH5Ev0ZzIpq/GAq9N926+rdvbSks3LWLfxp7sq2cX5gUqLDF8+vijTy5lS3Qtrcfr5UkMwkAk+hjKDvdCSYmvOkzQdonTGkVKEbThMYOb01D9ga++SL09cNXVz0OGTEprBYe/tq8MR4qYCsL8zlSli2eTG7kqSaJthbZrD+JSVVug80XLgcmMbtCTBx20mi3T7Rq0itQjCaTacQOIWxyuz+6Fvr9H69dW+komEkMCtiKMHXC3crGdcvNzcu3k5c2FDRk2GILEkzgtW/aOt/9HDFxC7cyICYaEwlcRuwklU6BYjTF5M49v3js2OLi4opazDPZ1SwEyq7qjfHKgajkHjqUm7z+5ZmAJBF/cpy8XrHo/h9gcmV/L/9/ACQAC+WwmwJpljzJTADK4uKVBysrI2JSXV2InjleXQ31Z2PCcXJjSvqaGBOtP6UWB+ZecP/vlK+z3Bp9hYdiHyHtrRPQoQTsI+nEpCrXnWBS5X5w5cqDJ3kscthdg4M4VpKZYFtJIUKOtKLFjPZ4uzbFY+HbuIFJZzgatXrw60mwkQm7HZiMpBcT+Em742GCjvU96eb4wEHeSXZVr2KySg67xo6b2NoVPRuIfBCh+/f3xn/XDuCgjFCSHVCVf6zr+VFUhQ/fmFJ+2CtEqvfHDPb7mJBQX9VNrFa7srfnP+upcrsTXx2AzgSZrF2TVmGCVIWc8rvba1K9RXDY72WC9tHQsz+exGSlAvwWcmvgu1/2TPQ9Az9kGpQRJ9D3McGn4AI9hL/shzCpEqFDxqb0SpwfKOyj6u55DOW7mRjdbrTDWE+XSYHJdz6OHH/XANTjdEucH6YqnsrX38+Eb95IfV2ZtAyYfGdO8iUrvRaA/4gwFQqV5e9mIqriKVDufikw+W6bqlpRyDNO+ALUgYPV53/Y6/We/u//ncQZT4VPoB/8q/xI6oe8MtOh/FN+qlVpMor9f6sqZW8vK15ZJFlllVVWWWWVVVZZZZVVVllllVVWWWWVVVZZZZXVD9f/ATiJOI/yOFbcAAAAAElFTkSuQmCC" alt="" />
              <p><strong>Tech Stack : </strong><span> abc</span></p>
              <p>Description</p>

            </div>
            <div className="three same">
              <img src="https://accesto.com/blog/static/d34d03b00e61fdc315c4fcfffdc70c07/f3583/software-development-life-cycle-sdlc.png" alt="" />
              <p><strong>Tech Stack : </strong><span> abc</span></p>
              <p>Description</p>

            </div>

          </div>

        </div>



        <div className="latstArticleContainer">
          <div className="latestarticlrowone">
            <div className="one same">
              <img src="https://blog.planview.com/wp-content/uploads/2020/01/Top-6-Software-Development-Methodologies.jpg" alt="" />
              <p><strong>Tech Stack : </strong><span> abc</span></p>
              <p>Description</p>
            </div>
            <div className="two same">
              <img src="https://blog.planview.com/wp-content/uploads/2020/01/Top-6-Software-Development-Methodologies.jpg" alt="" />
              <p><strong>Tech Stack : </strong><span> abc</span></p>
              <p>Description</p>

            </div>
            <div className="three same">
              <img src="https://blog.planview.com/wp-content/uploads/2020/01/Top-6-Software-Development-Methodologies.jpg" alt="" />
              <p><strong>Tech Stack : </strong><span> abc</span></p>
              <p>Description</p>

            </div>

          </div>

        </div>

        <div className="homeChart">
          <div className="homeChartWritten">
            <h2>Analysis of Project</h2>
          </div>
          <div className="homechartgraph">
            <BarChart
              width={800}
              height={350}
              data={data}
            // margin={{
            //   top: 20,
            //   right: 30,
            //   left: 20,
            //   bottom: 5
            // }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              {/* <Legend /> */}
              <Bar dataKey="pv" stackId="a" fill="crimson" />
              {/* <Bar dataKey="amt" stackId="a" fill="green" /> */}
              {/* <Bar dataKey="uv" fill="gray" /> */}
            </BarChart>
          </div>
        </div>


        <div className='homepaycontainer'>

          <div className="homePaySection">
            <div className="homepayleft">
              <h2>Contribute</h2>
              <p>If you think, we are doing well and this website is helpful for you. Motivate us by contributing amount you are affordable by scanning <strong>QRCODE</strong>. Show in the right side. <strong>Each Quiz</strong> will be discissed throught the YouTube video</p>
            </div>
            <div className="homepayright">
              <img src={qrcode} alt="" />
            </div>
          </div>
        </div>




        {/* <div className="homeheadercon">
         <div className="headerHome">

          <div className='headerTitle'>
          <h1>Take a look at latest project</h1>

           <h2><span className='titleUnderline'></span><span className='spanTitle'>You can contribute for a cause 👉</span><span className='titleUnderline'></span></h2>
          </div>
          <div className='headerQr'>
            <img src={qrcode} alt="" />
          </div>
            
        </div>
         </div> */}

        {/* <div className="project">
          <div className="twocardinrow">
            <div className="card">
              <div className="img">
                <ReactPlayer
                width={"100%"}
                // height={""}
                autoPlay={true}
                muted={true}
                 className="reactvid" url='https://www.youtube.com/watch?v=ysz5S6PUM-U' />

              </div>
             
             
              
            </div>
            <div className="card">
              
              <div className="tech">
                <h2>Title</h2>
                <h3>Tech Stack : <span>React</span> </h3>
                <h3>Concept Used : <span>abcd</span> </h3>
                <p> <strong>Description :</strong>  Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique animi vel recusandae laborum nisi odio perspiciatis eaque et mollitia. Libero rerum in totam. </p>

                <a href="#"><button>Get Code</button></a>
              </div> 
            </div>
          </div>
          <div className="twocardinrow">
          <div className="card">
              
              <div className="tech">
                <h2>Title</h2>
                <h3>Tech Stack : <span>React</span> </h3>
                <h3>Concept Used : <span>abcd</span> </h3>
                <p>Description : </p>

                <a href="#"><button>Get Code</button></a>
              </div> 
            </div>
            <div className="card">
              <div className="img">
                <ReactPlayer
                width={"100%"}
                autoPlay={true}
                muted={true}
                 className="reactvid" url='https://www.youtube.com/watch?v=ysz5S6PUM-U' />

              </div>
              
             
              
            </div>
           
          </div>
          <div className="twocardinrow">
            <div className="card">
              <div className="img">
                <ReactPlayer
                width={"100%"}
                autoPlay={true}
                muted={true}
                 className="reactvid" url='https://www.youtube.com/watch?v=ysz5S6PUM-U' />

              </div>
              
             
              
            </div>
            <div className="card">
             
              <div className="tech">
                <h2>Title</h2>
                <h3>Tech Stack : <span>React</span> </h3>
                <h3>Concept Used : <span>abcd</span> </h3>
                <p>Description : </p>

                <a href="#"><button>Get Code</button></a>
              </div> 
            </div>
          </div>
        </div> */}
      </div>
    </>
  )
}

export default Home;
